import QRCode from 'qrcode'

export async function generateQrCode(content: string): Promise<string> {
  const data = await QRCode.toDataURL(content)

  return data
}
